import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import PageRouter from './PageRouter'
import './styles/index.scss'

createRoot(document.getElementById('tv-guide-placeholder')!).render(
  <StrictMode>
    <PageRouter />
  </StrictMode>
)
